module.exports = __webpack_public_path__ + "img/soul-land3d.5b953dc.png";